module.exports = __webpack_public_path__ + "static/media/Payroll.f97a7292.svg";